// RB-MY01-PalmGarden.web/src/components/AdminLayout.tsx
import React from 'react';
import AdminNavigation from './AdminNavigation';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  return (
    <AdminNavigation>
      {children}
    </AdminNavigation>
  );
};

export default AdminLayout; 